import React, { useState, useEffect } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';
import { Logo } from './Logo';
import { Button } from './ui/button';

const Header = ({ lang, setLang, t, onQuoteClick }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const navItems = [
    { id: 'what', label: t.nav.what },
    { id: 'why', label: t.nav.why },
    { id: 'how', label: t.nav.how },
    { id: 'who', label: t.nav.who },
    { id: 'contact', label: t.nav.contact },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? 'bg-black/85 backdrop-blur-xl border-b border-white/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button onClick={() => scrollTo('top')} className="flex items-center">
          <Logo />
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="relative px-4 py-2 text-sm text-zinc-300 hover:text-white transition-colors group"
            >
              <span>{item.label}</span>
              <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-[#004aad] scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <div className="flex items-center text-xs text-zinc-400">
            <button
              onClick={() => setLang('fr')}
              className={`px-2 py-1 transition-colors ${
                lang === 'fr' ? 'text-white font-semibold' : 'hover:text-white'
              }`}
            >
              FR
            </button>
            <span className="text-zinc-700">|</span>
            <button
              onClick={() => setLang('en')}
              className={`px-2 py-1 transition-colors ${
                lang === 'en' ? 'text-white font-semibold' : 'hover:text-white'
              }`}
            >
              EN
            </button>
          </div>
          <Button
            onClick={onQuoteClick}
            className="bg-[#004aad] hover:bg-[#0057cc] text-white rounded-full px-5 h-10 font-medium"
          >
            {t.nav.quote}
            <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </div>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-white/5">
          <div className="flex flex-col p-6 gap-2">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="text-left py-3 text-zinc-200 hover:text-white border-b border-white/5"
              >
                {item.label}
              </button>
            ))}
            <div className="flex items-center justify-between pt-4">
              <div className="flex items-center text-sm text-zinc-400">
                <button
                  onClick={() => setLang('fr')}
                  className={`px-3 ${lang === 'fr' ? 'text-white font-semibold' : ''}`}
                >
                  FR
                </button>
                <span>|</span>
                <button
                  onClick={() => setLang('en')}
                  className={`px-3 ${lang === 'en' ? 'text-white font-semibold' : ''}`}
                >
                  EN
                </button>
              </div>
              <Button
                onClick={() => {
                  setOpen(false);
                  onQuoteClick();
                }}
                className="bg-[#004aad] hover:bg-[#0057cc] text-white rounded-full px-5"
              >
                {t.nav.quote}
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
